module.exports = __webpack_public_path__ + "img/bbht2.0148f602.jpg";